import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserModel } from '../../_models/user.model';
import { environment } from '../../../../../environments/environment';
import { tokenize } from '@angular/compiler/src/ml_parser/lexer';

const API_USERS_URL = '';

@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {
  constructor(private http: HttpClient) { }

  // public methods
  accountSignUp(req: any): Observable<any> 
  {
      return this.http.post(environment.API + 'accounts', req);
  }
  
  login(req:any): Observable<any>{
      return this.http.post(environment.API + 'users/authenticate?loginForm=Web', req);
  }

  // Your server should check email => If email exists send link to the user and return true | If email doesn't exist return false
  forgotPassword(req: any): Observable<any> {
    return this.http.post(environment.API + 'users/forgot-password',req);
  }

  userInfo(): Observable<any> {
    return this.http.get(environment.API + 'users');
  }

  changePassword(req: any): Observable<any> {
    return this.http.post(environment.API + 'users/change-password',req);
  }

  getUserByToken(token): Observable<UserModel> {
    const httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.get<UserModel>(`${API_USERS_URL}/me`, {
      headers: httpHeaders,
    });
  }

  refreshToken(req:any): Observable<any> {
    return this.http.post(environment.API + 'users/refresh-token',req);
  }

}
